import type { FC } from 'react';
import styled, { keyframes } from 'styled-components';
import SvgIconWrapper from './SvgIconWrapper';
import queries from './container-queries.module.css';
import { ReactComponent as AddToList } from './svgs/add-to-list.svg';
import { ReactComponent as AdminShieldCookie } from './svgs/admin-shield-cookie.svg';
import { ReactComponent as AdminShield } from './svgs/admin-shield.svg';
import { ReactComponent as AnalyzeAlt } from './svgs/analyze-alt.svg';
import { ReactComponent as AnalyzeMenu } from './svgs/analyze-menu.svg';
import { ReactComponent as AnalyzeNavigationActive } from './svgs/analyze-navigation-active.svg';
import { ReactComponent as Analyze } from './svgs/analyze.svg';
import { ReactComponent as ArrowDownRight } from './svgs/arrow-down-right.svg';
import { ReactComponent as ArrowDown } from './svgs/arrow-down.svg';
import { ReactComponent as ArrowRight } from './svgs/arrow-right.svg';
import { ReactComponent as ArrowUpRight } from './svgs/arrow-up-right.svg';
import { ReactComponent as ArrowUp } from './svgs/arrow-up.svg';
import { ReactComponent as Astromech } from './svgs/astromech.svg';
import { ReactComponent as Benchmark } from './svgs/benchmark.svg';
import { ReactComponent as Binoculars } from './svgs/binoculars.svg';
import { ReactComponent as Blog } from './svgs/blog.svg';
import { ReactComponent as Boolean } from './svgs/boolean.svg';
import { ReactComponent as Code } from './svgs/browser-embed.svg';
import { ReactComponent as Calendar } from './svgs/calendar.svg';
import { ReactComponent as Chat } from './svgs/chat.svg';
import { ReactComponent as Check } from './svgs/check.svg';
import { ReactComponent as ChevronDown } from './svgs/chevron-down.svg';
import { ReactComponent as ChevronLeft } from './svgs/chevron-left.svg';
import { ReactComponent as ChevronRight } from './svgs/chevron-right.svg';
import { ReactComponent as ChevronUp } from './svgs/chevron-up.svg';
import { ReactComponent as CircleCheck } from './svgs/circle-check.svg';
import { ReactComponent as CircleClock } from './svgs/circle-clock.svg';
import { ReactComponent as CircleCross } from './svgs/circle-cross.svg';
import { ReactComponent as CircleError } from './svgs/circle-error.svg';
import { ReactComponent as CircleInfoFilled } from './svgs/circle-info-filled.svg';
import { ReactComponent as CircleInfo } from './svgs/circle-info.svg';
import { ReactComponent as CirclePlus } from './svgs/circle-plus.svg';
import { ReactComponent as CircleQuestion } from './svgs/circle-question.svg';
import { ReactComponent as CircleSlash } from './svgs/circle-slash.svg';
import { ReactComponent as CircleUser } from './svgs/circle-user.svg';
import { ReactComponent as Close } from './svgs/close.svg';
import { ReactComponent as Collapse } from './svgs/collapse.svg';
import { ReactComponent as Comment } from './svgs/comment.svg';
import { ReactComponent as Computer } from './svgs/computer.svg';
import { ReactComponent as ContactPlus } from './svgs/contact-add.svg';
import { ReactComponent as ContactCheck } from './svgs/contact-check.svg';
import { ReactComponent as Contact } from './svgs/contact.svg';
import { ReactComponent as ContactsNavigationActive } from './svgs/contacts-navigation-active.svg';
import { ReactComponent as ContactsNavigation } from './svgs/contacts-navigation.svg';
import { ReactComponent as Contacts } from './svgs/contacts.svg';
import { ReactComponent as CreditCard } from './svgs/credit-card.svg';
import { ReactComponent as CrowFancy } from './svgs/crown-fancy.svg';
import { ReactComponent as Crown } from './svgs/crown.svg';
import { ReactComponent as DashboardActive } from './svgs/dashboard-active.svg';
import { ReactComponent as Dashboard } from './svgs/dashboard.svg';
import { ReactComponent as DebugCookie } from './svgs/debug-cookie.svg';
import { ReactComponent as Debug } from './svgs/debug.svg';
import { ReactComponent as DefaultThumbnail } from './svgs/default-thumbnail.svg';
import { ReactComponent as DeleteSchedule } from './svgs/delete-schedule.svg';
import { ReactComponent as Delete } from './svgs/delete.svg';
import { ReactComponent as Diamond } from './svgs/diamond.svg';
import { ReactComponent as Differences } from './svgs/differences.svg';
import { ReactComponent as DollarSign } from './svgs/dollar-sign.svg';
import { ReactComponent as Download } from './svgs/download.svg';
import { ReactComponent as EasterEgg } from './svgs/easter-egg.svg';
import { ReactComponent as Edit } from './svgs/edit.svg';
import { ReactComponent as EmailSchedule } from './svgs/email-schedule.svg';
import { ReactComponent as Email } from './svgs/email.svg';
import { ReactComponent as Expand } from './svgs/expand.svg';
import { ReactComponent as ExternalLink } from './svgs/external-link.svg';
import { ReactComponent as Forum } from './svgs/forum.svg';
import { ReactComponent as Globe } from './svgs/globe.svg';
import { ReactComponent as HeartFilled } from './svgs/heart-filled.svg';
import { ReactComponent as Heart } from './svgs/heart.svg';
import { ReactComponent as Image } from './svgs/image.svg';
import { ReactComponent as LayoutCompact } from './svgs/layout-compact.svg';
import { ReactComponent as LayoutStandard } from './svgs/layout-standard.svg';
import { ReactComponent as LearningVideo } from './svgs/learning-video.svg';
import { ReactComponent as Lightbulb } from './svgs/lightbulb.svg';
import { ReactComponent as Lighthouse } from './svgs/lighthouse.svg';
import { ReactComponent as Link } from './svgs/link.svg';
import { ReactComponent as List } from './svgs/list.svg';
import { ReactComponent as LockLocked } from './svgs/lock-locked.svg';
import { ReactComponent as LockUnlocked } from './svgs/lock-unlocked.svg';
import { ReactComponent as Menu } from './svgs/menu.svg';
import { ReactComponent as Minus } from './svgs/minus.svg';
import { ReactComponent as MndFilled } from './svgs/mnd-filled.svg';
import { ReactComponent as MonitorNavigationActive } from './svgs/monitor-navigation-active.svg';
import { ReactComponent as MonitorNavigation } from './svgs/monitor-navigation.svg';
import { ReactComponent as Monitor } from './svgs/monitor.svg';
import { ReactComponent as Moon } from './svgs/moon.svg';
import { ReactComponent as MoreHorizontal } from './svgs/more-horizontal.svg';
import { ReactComponent as MoreVertical } from './svgs/more-vertical.svg';
import { ReactComponent as Newsroom } from './svgs/newsroom.svg';
import { ReactComponent as Notification } from './svgs/notification.svg';
import { ReactComponent as Paperclip } from './svgs/paperclip.svg';
import { ReactComponent as PasswordUnlock } from './svgs/password-unlock.svg';
import { ReactComponent as Pen } from './svgs/pen.svg';
import { ReactComponent as Pencil } from './svgs/pencil.svg';
import { ReactComponent as Phone } from './svgs/phone.svg';
import { ReactComponent as PinFilled } from './svgs/pin-filled.svg';
import { ReactComponent as Pin } from './svgs/pin.svg';
import { ReactComponent as Plane } from './svgs/plane.svg';
import { ReactComponent as PlayFilled } from './svgs/play-filled.svg';
import { ReactComponent as Play } from './svgs/play.svg';
import { ReactComponent as Plus } from './svgs/plus.svg';
import { ReactComponent as Podcast } from './svgs/podcast.svg';
import { ReactComponent as PrAssistant } from './svgs/pr-assistant.svg';
import { ReactComponent as PublishActive } from './svgs/publish-active.svg';
import { ReactComponent as Publish } from './svgs/publish.svg';
import { ReactComponent as Radio } from './svgs/radio.svg';
import { ReactComponent as Reach } from './svgs/reach.svg';
import { ReactComponent as Refresh } from './svgs/refresh.svg';
import { ReactComponent as Replace } from './svgs/replace.svg';
import { ReactComponent as Report } from './svgs/report.svg';
import { ReactComponent as ReportsActive } from './svgs/reports-active.svg';
import { ReactComponent as Rss } from './svgs/rss.svg';
import { ReactComponent as Search } from './svgs/search.svg';
import { ReactComponent as Section } from './svgs/section.svg';
import { ReactComponent as SentimentNegative } from './svgs/sentiment-negative.svg';
import { ReactComponent as SentimentNeutral } from './svgs/sentiment-neutral.svg';
import { ReactComponent as SentimentPositive } from './svgs/sentiment-positive.svg';
import { ReactComponent as Settings } from './svgs/settings.svg';
import { ReactComponent as ShareOfVoice } from './svgs/share-of-voice.svg';
import { ReactComponent as Share } from './svgs/share.svg';
import { ReactComponent as SidebarOpened } from './svgs/sidebar-open.svg';
import { ReactComponent as SidebarClosed } from './svgs/sidebar.svg';
import { ReactComponent as Similarities } from './svgs/similarities.svg';
import { ReactComponent as Sliders } from './svgs/sliders.svg';
import { ReactComponent as Facebook } from './svgs/social-facebook.svg';
import { ReactComponent as Instagram } from './svgs/social-instagram.svg';
import { ReactComponent as LinkedIn } from './svgs/social-linkedin.svg';
import { ReactComponent as SocialMedia } from './svgs/social-media.svg';
import { ReactComponent as Mnd } from './svgs/social-mnd.svg';
import { ReactComponent as X } from './svgs/social-x.svg';
import { ReactComponent as Youtube } from './svgs/social-youtube.svg';
import { ReactComponent as Soundwaves } from './svgs/soundwaves.svg';
import { ReactComponent as Sparkle } from './svgs/sparkle.svg';
import { ReactComponent as StarFilled } from './svgs/star-filled.svg';
import { ReactComponent as Star } from './svgs/star.svg';
import { ReactComponent as Stop } from './svgs/stop.svg';
import { ReactComponent as Story } from './svgs/story.svg';
import { ReactComponent as Sun } from './svgs/sun.svg';
import { ReactComponent as TextFile } from './svgs/text-file.svg';
import { ReactComponent as ThumbsDownFilled } from './svgs/thumbs-down-filled.svg';
import { ReactComponent as ThumbsDown } from './svgs/thumbs-down.svg';
import { ReactComponent as ThumbsUpFilled } from './svgs/thumbs-up-filled.svg';
import { ReactComponent as ThumbsUp } from './svgs/thumbs-up.svg';
import { ReactComponent as Time } from './svgs/time.svg';
import { ReactComponent as Translate } from './svgs/translate.svg';
import { ReactComponent as TriangleExclamation } from './svgs/triangle-exclamation.svg';
import { ReactComponent as TriangleWarning } from './svgs/triangle-warning.svg';
import { ReactComponent as TV } from './svgs/tv.svg';
import { ReactComponent as TvWeb } from './svgs/tv_web.svg';
import { ReactComponent as Upload } from './svgs/upload.svg';
import { ReactComponent as User } from './svgs/user.svg';
import { ReactComponent as VisibilityOff } from './svgs/visibility-off.svg';
import { ReactComponent as Visibility } from './svgs/visibility.svg';
import { ReactComponent as Web } from './svgs/web.svg';
import { ReactComponent as Written } from './svgs/written.svg';

const wrapIcon = (Component: FC) => styled(SvgIconWrapper).attrs({ children: <Component /> })``;

export type WrapIconComponentType = ReturnType<typeof wrapIcon>;

const eyesAnimation = keyframes`
  0% {
    transform: scale(1,1);
    animation-timing-function: cubic-bezier(0.645,0.045,0.355,1);
  }
  2% {
    transform: scale(1,0.04207);
    animation-timing-function: cubic-bezier(0.645,0.045,0.355,1);
  }
  4% {
    transform: scale(1,1);
  }
  34% {
    transform: scale(1,1);
  }
  36% {
    transform: scale(1,0.04207);
    animation-timing-function: cubic-bezier(0.645,0.045,0.355,1);
  }
  38% {
    transform: scale(1,1);
  }
  59% {
    transform: scale(1,1);
  }
  61% {
    transform: scale(1,0.04207);
    animation-timing-function: cubic-bezier(0.645,0.045,0.355,1);
  }
  62% {
    transform: scale(1,1)
  }
  63% {
    transform: scale(1,0.04207);
    animation-timing-function: cubic-bezier(0.645,0.045,0.355,1);
  }
  65% {
    transform: scale(1,1);
  }
  100% {
    transform: scale(1,1);
  }
`;

const WrappedPrAssistant = styled(SvgIconWrapper).attrs({
  children: <PrAssistant className={queries['pr-assistant']} />,
})`
  container-type: inline-size;
  [data-pr-assistant-eyes='true'] {
    transform-origin: center 47%;
    animation: ${eyesAnimation} 10000ms linear infinite normal;
  }
`;

const Warning = styled(TriangleExclamation)`
  color: ${props => props.theme.colorIconsWarning};
`;

const Error = styled(TriangleExclamation)`
  color: ${props => props.theme.colorIconsDanger};
`;

export const IconsSocialMedia = {
  Facebook: wrapIcon(Facebook),
  Instagram: wrapIcon(Instagram),
  LinkedIn: wrapIcon(LinkedIn),
  Youtube: wrapIcon(Youtube),
  X: wrapIcon(X),
};

export const IconArrows = {
  ArrowDown: wrapIcon(ArrowDown),
  ArrowDownRight: wrapIcon(ArrowDownRight),
  ArrowUp: wrapIcon(ArrowUp),
  ArrowUpRight: wrapIcon(ArrowUpRight),
  ArrowRight: wrapIcon(ArrowRight),

  ChevronLeft: wrapIcon(ChevronLeft),
  ChevronDown: wrapIcon(ChevronDown),
  ChevronUp: wrapIcon(ChevronUp),
  ChevronRight: wrapIcon(ChevronRight),
};

export const IconNotifications = {
  Notification: wrapIcon(Notification),
  CircleQuestion: wrapIcon(CircleQuestion),
  CircleError: wrapIcon(CircleError),
  CircleInfo: wrapIcon(CircleInfo),
  CircleInfoFilled: wrapIcon(CircleInfoFilled),
  TriangleWarning: wrapIcon(TriangleWarning),
  Warning: wrapIcon(Warning),
  Error: wrapIcon(Error),
};

export const IconReactions = {
  SentimentPositive: wrapIcon(SentimentPositive),
  SentimentNegative: wrapIcon(SentimentNegative),
  SentimentNeutral: wrapIcon(SentimentNeutral),

  ThumbsUpFilled: wrapIcon(ThumbsUpFilled),
  ThumbsUp: wrapIcon(ThumbsUp),
  ThumbsDownFilled: wrapIcon(ThumbsDownFilled),
  ThumbsDown: wrapIcon(ThumbsDown),
};

// Icons used for features that are acknowledged universally.
export const IconFeaturesUniversal = {
  Blog: wrapIcon(Blog),
  Calendar: wrapIcon(Calendar),
  Collapse: wrapIcon(Collapse),
  Close: wrapIcon(Close),
  Chat: wrapIcon(Chat),
  Check: wrapIcon(Check),
  CircleSlash: wrapIcon(CircleSlash),
  CircleUser: wrapIcon(CircleUser),
  Comment: wrapIcon(Comment),
  Contact: wrapIcon(Contact),
  ContactPlus: wrapIcon(ContactPlus),
  ContactCheck: wrapIcon(ContactCheck),
  Contacts: wrapIcon(Contacts),
  DarkMode: wrapIcon(Moon),
  Delete: wrapIcon(Delete),
  DeleteSchedule: wrapIcon(DeleteSchedule),
  Download: wrapIcon(Download),
  Edit: wrapIcon(Edit),
  Email: wrapIcon(Email),
  EmailSchedule: wrapIcon(EmailSchedule),
  Expand: wrapIcon(Expand),
  ExternalLink: wrapIcon(ExternalLink),
  Forum: wrapIcon(Forum),
  Image: wrapIcon(Image), // thumbnail (name in Design System)
  LightMode: wrapIcon(Sun),
  Link: wrapIcon(Link),
  List: wrapIcon(List),
  Menu: wrapIcon(Menu),
  MoreHorizontal: wrapIcon(MoreHorizontal),
  MoreVertical: wrapIcon(MoreVertical),
  Play: wrapIcon(Play),
  Refresh: wrapIcon(Refresh),
  Replace: wrapIcon(Replace),
  Rss: wrapIcon(Rss),
  Search: wrapIcon(Search),
  Settings: wrapIcon(Settings),
  Share: wrapIcon(Share),
  Sliders: wrapIcon(Sliders),
  Translate: wrapIcon(Translate),
  Upload: wrapIcon(Upload),
  User: wrapIcon(User),
  Visibility: wrapIcon(Visibility),
  VisibilityOff: wrapIcon(VisibilityOff),
};

// Icons that are defined for MND's specific features.
export const IconFeaturesSpecial = {
  AddToList: wrapIcon(AddToList),
  Analyze: wrapIcon(Analyze),
  AnalyzeAlt: wrapIcon(AnalyzeAlt),
  Benchmark: wrapIcon(Benchmark),
  ContactsNavigation: wrapIcon(ContactsNavigation),
  ContactsNavigationActive: wrapIcon(ContactsNavigationActive),
  Dashboard: wrapIcon(Dashboard), // grid-view (name in Design System)
  DashboardActive: wrapIcon(DashboardActive),
  Debug: wrapIcon(Debug),
  DebugCookie: wrapIcon(DebugCookie),
  Mnd: wrapIcon(Mnd),
  MonitorNavigation: wrapIcon(MonitorNavigation),
  MonitorNavigationActive: wrapIcon(MonitorNavigationActive),
  Newsroom: wrapIcon(Newsroom),
  PrAssistant: WrappedPrAssistant,
  Publish: wrapIcon(Publish),
  PublishActive: wrapIcon(PublishActive),
  Reach: wrapIcon(Reach),
  Report: wrapIcon(Report),
  ReportsActive: wrapIcon(ReportsActive),
  Section: wrapIcon(Section),
  ShareOfVoice: wrapIcon(ShareOfVoice),
  SidebarOpened: wrapIcon(SidebarOpened), // hide-sidebar
  SidebarClosed: wrapIcon(SidebarClosed), // show-sidebar
  Story: wrapIcon(Story),
};

export const IconGeneral = {
  AdminShield: wrapIcon(AdminShield), // shield
  Astromech: wrapIcon(Astromech),
  Binoculars: wrapIcon(Binoculars),
  Boolean: wrapIcon(Boolean),
  CircleCheck: wrapIcon(CircleCheck),
  CircleCross: wrapIcon(CircleCross),
  CirclePlus: wrapIcon(CirclePlus),
  CreditCard: wrapIcon(CreditCard),
  Differences: wrapIcon(Differences),
  DollarSign: wrapIcon(DollarSign),
  EasterEgg: wrapIcon(EasterEgg),
  Globe: wrapIcon(Globe),
  Heart: wrapIcon(Heart),
  HeartFilled: wrapIcon(HeartFilled),
  LockLocked: wrapIcon(LockLocked), // lock
  LockUnlocked: wrapIcon(LockUnlocked), // unlock
  Minus: wrapIcon(Minus),
  Pen: wrapIcon(Pen), // edit-pen
  Pin: wrapIcon(Pin),
  PinFilled: wrapIcon(PinFilled),
  Plane: wrapIcon(Plane),
  Plus: wrapIcon(Plus),
  Podcast: wrapIcon(Podcast),
  Radio: wrapIcon(Radio),
  Similarities: wrapIcon(Similarities),
  Sparkle: wrapIcon(Sparkle), // star-dust
  Star: wrapIcon(Star),
  StarFilled: wrapIcon(StarFilled),
  TvWeb: wrapIcon(TvWeb),
  Web: wrapIcon(Web),
};
// Icons that haven't been sorted yet or are not even in the Design System.
export const IconMiscellaneous = {
  CircleClock: wrapIcon(CircleClock),
  Crown: wrapIcon(Crown),
  CrownFancy: wrapIcon(CrowFancy),
  DefaultThumbnail: wrapIcon(DefaultThumbnail),
  Diamond: wrapIcon(Diamond),
  Computer: wrapIcon(Computer),
  Lighthouse: wrapIcon(Lighthouse),
  PasswordUnlock: wrapIcon(PasswordUnlock),
  Pencil: wrapIcon(Pencil),
  Code: wrapIcon(Code),
  Written: wrapIcon(Written),
  LearningVideo: wrapIcon(LearningVideo),
  TextFile: wrapIcon(TextFile),
  Phone: wrapIcon(Phone),
  Paperclip: wrapIcon(Paperclip),
  Time: wrapIcon(Time),
  Monitor: wrapIcon(Monitor),
  AnalyzeMenu: wrapIcon(AnalyzeMenu),
  Lightbulb: wrapIcon(Lightbulb),
  MndFilled: wrapIcon(MndFilled),
  AnalyzeNavigationActive: wrapIcon(AnalyzeNavigationActive),
  SocialMedia: wrapIcon(SocialMedia), // smartphone
  TV: wrapIcon(TV),
  AdminShieldCookie: wrapIcon(AdminShieldCookie),
  LayoutStandard: wrapIcon(LayoutStandard),
  LayoutCompact: wrapIcon(LayoutCompact),
  PlayFilled: wrapIcon(PlayFilled),
  Stop: wrapIcon(Stop),
  Soundwaves: wrapIcon(Soundwaves),
};

export const Icons = {
  ...IconMiscellaneous,
  ...IconsSocialMedia,
  ...IconArrows,
  ...IconNotifications,
  ...IconGeneral,
  ...IconFeaturesUniversal,
  ...IconFeaturesSpecial,
  ...IconReactions,
};

export default Icons;
